import { render, staticRenderFns } from "./HubContactCta.vue?vue&type=template&id=1f15148a&scoped=true"
import script from "./HubContactCta.vue?vue&type=script&lang=js"
export * from "./HubContactCta.vue?vue&type=script&lang=js"
import style0 from "./HubContactCta.vue?vue&type=style&index=0&id=1f15148a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f15148a",
  null
  
)

export default component.exports